import styles from "./Badge.module.scss";
type BadgeProps = {
  badgeCount?: number;
};

function Badge({ badgeCount }: BadgeProps) {
  return badgeCount ? (
    <div className={styles.badgeContainer}>
      <div>{badgeCount}</div>
    </div>
  ) : null;
}
export default Badge;
